<template>
  <div ref="shops" class="shops">
    <div class="shops__count">
      {{ $t("FL2") }} {{ getStoresCount ? `(${getStoresCount})` : "" }}
    </div>
    <div v-if="getStores.length > 0" class="shops__container">
      <Checkbox
        v-for="(store, index) in getStores"
        :key="index"
        :index="index"
        :text="store.store_name"
        :checked="store.selected"
        @changed="checkStore"
        class="shops__shop"
      ></Checkbox>
    </div>
    <div v-else class="shops__container shops__container--preloader">
      <CheckboxPreloader
        class="shops__shop shops__shop--preloader"
        v-for="(n, index) in checkboxPlaceholders"
        :key="index"
        :long="n"
      />
    </div>
  </div>
</template>

<script>
import Checkbox from "./Checkbox";
import { mapGetters } from "vuex";
import CheckboxPreloader from "@/components/common/preloaders/CheckboxPreloader";

export default {
  name: "ShopsFilter",
  components: { CheckboxPreloader, Checkbox },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("products", ["getStores", "getStoresCount"]),
    checkboxPlaceholders() {
      return new Array(20)
        .fill(1)
        .map((a, index) => [5, 6, 7, 8, 9, 15, 16, 17, 18, 19].includes(index));
    }
  },
  methods: {
    up() {
      this.$refs.shops.scrollTop = 0;
    },
    checkStore(storeName, checked) {
      this.$store.dispatch("products/selectStore", {
        name: storeName,
        selected: checked
      });
    }
  }
};
</script>

<style scoped lang="scss">
.shops {
  position: relative;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  max-height: 157px;
  padding-top: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  left: 1px;
  &__count {
    position: relative;
    margin-bottom: 9px;
    color: #060606;
    font-family: Lato, sans-serif;
    font-size: 14px;
    left: 1px;
  }
  &__container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
    &--preloader {
      margin-bottom: 15px;
    }
  }
  &__shop {
    width: 173px;
    margin-right: 20px;
    margin-bottom: 4px;
    &:nth-child(5n + 2) {
      margin-right: 19px;
    }
    &:nth-child(5n + 3) {
      margin-right: 21px;
    }
    &:nth-child(5n + 4) {
      margin-right: 19px;
    }
    &:nth-child(5n) {
      margin-right: 0;
      width: calc(173px - 20px);
    }
    &:nth-last-child(1),
    &:nth-last-child(2),
    &:nth-last-child(3),
    &:nth-last-child(4),
    &:nth-last-child(5) {
      margin-bottom: 0;
    }
    &--preloader {
      display: block;
      height: 20px;
      width: 193px;
      left: -1px;
      &:nth-child(5n + 1),
      &:nth-child(5n + 2),
      &:nth-child(5n + 3),
      &:nth-child(5n + 4),
      &:nth-child(5n + 5) {
        margin-right: 0;
        margin-left: 0px;
      }
    }
  }
}
</style>
